import { Button, Form, Modal, Spinner } from "react-bootstrap";

export default function DeleteDomain({
  domain,
  showModal,
  loading,
  onClose,
  onDelete,
  deleteError,
}) {
  const deleteDomain = () => {
    onDelete(domain);
  };
  return (
    <Modal show={showModal} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete domain</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {!deleteError && (
            <label>
              Are you sure that you want to delete{" "}
              <strong>{domain?.domain}</strong> ?
            </label>
          )}
          {deleteError && (
            <label className="text-warning w-100 text-center">
              <strong>{domain?.domain}</strong> is in use.{" "}
            </label>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {!deleteError && (
          <Button
            disabled={loading}
            className="btn btn-sm btn-danger rounded-pill mr-auto"
            onClick={deleteDomain}
          >
            {loading ? (
              <Spinner size="sm" animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            ) : (
              "Delete"
            )}
          </Button>
        )}

        <Button
          variant="secondary"
          disabled={loading}
          className="btn btn-sm btn-link text-muted px-2"
          onClick={onClose}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
